<template>
  <div class="custom-file">
    <input type="file"
           class="custom-file-input"
           id="customFileLang"
           lang="pt-BR"
           :key="files && files.length"
           v-bind="$attrs"
           v-on="listeners"
    />
    <label class="custom-file-label" for="customFileLang">
      {{label}}
    </label>
  </div>
</template>
<script>
  export default {
    name: 'file-input',
    inheritAttrs: false,
    props: {
      initialLabel: {
        type: String,
        default: 'Enviar arquivo'
      },
      files: {
        type: Array,
        default: () => [],
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          change: this.fileChange
        }
      },
      label() {
        let fileNames = [];
        for (let file of this.filesHandler) {
          fileNames.push(file.name)
        }
        
        return fileNames.length ? fileNames.join(', ') : this.initialLabel
      },
      filesHandler: {
        set(value) {
          this.$emit('update:files', [...value])
        },
        get() {
          return this.files
        }
      }
    },
    methods: {
      fileChange(evt) {
        this.filesHandler = evt.target.files
      }
    }
  }
</script>
<style>
</style>
